module.exports = __webpack_public_path__ + "img/404.71390cd7.jpg";